import type { DispenseIdentity } from './dispensePreset'

let pending: DispenseIdentity | null = null
let lastHandledUrl = ''
let lastHandledAt = Number.NEGATIVE_INFINITY
const pendingListeners = new Set<() => void>()

export function stashPendingIdentity (identity: DispenseIdentity): void {
  const changed = !identitiesEqual(pending, identity)
  pending = identity
  if (changed) {
    notifyPendingListeners()
  }
}

export function peekPendingIdentity (): DispenseIdentity | null {
  return pending
}

export function consumePendingIdentity (): DispenseIdentity | null {
  const current = pending
  pending = null
  return current
}

export function consumePendingIdentityIf (identity: DispenseIdentity): void {
  if (identitiesEqual(pending, identity)) {
    pending = null
  }
}

export function subscribePendingIdentity (listener: () => void): () => void {
  pendingListeners.add(listener)
  return () => {
    pendingListeners.delete(listener)
  }
}

export function rememberHandledLaunchUrl (
  url: string,
  nowMs: number,
  windowMs = 1500,
): boolean {
  if (url === lastHandledUrl && nowMs - lastHandledAt < windowMs) {
    return false
  }

  lastHandledUrl = url
  lastHandledAt = nowMs
  return true
}

export function identitiesEqual (
  left: DispenseIdentity | null,
  right: DispenseIdentity,
): boolean {
  if (!left || left.via !== right.via) {
    return false
  }

  if (left.via === 'nfc' && right.via === 'nfc') {
    return left.nfc_id === right.nfc_id
  }

  if (left.via === 'qr' && right.via === 'qr') {
    return left.code === right.code
  }

  return false
}

function notifyPendingListeners (): void {
  for (const listener of pendingListeners) {
    listener()
  }
}
